<template>
  <!-- 选择模型组件 -->
  <el-cascader
    v-bind="$attrs"
    v-on="$listeners"
    :placeholder="placeholder"
    :options="options"
    :disabled="isdisabled"
    clearable
  ></el-cascader>
</template>

<script>
import store from '@/store'

export default {
  props: {
    options: {
      default: () => store.state.selectOptions.modelTypeTree
    },
    placeholder: {
      default: '请选择模型类型'
    },
    disableds:{
      default: false
    }
  },
  watch:{
    disableds(val){
      this.isdisabled =val
    }
  },
  data() {
    return {
      isdisabled: false
    }
  },
  created() {
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>

</style>
